export const Footer = () => {
    return <footer>© 2023 ShareLink by Jesús y Diango</footer>;
  };
  